import {
  TOrderCost,
  TOrderCostV1,
  TOrderCostV2,
  TOrderCostV3,
  TOrderCostV4, TOrderCostV5,
  TOrderCostV6,
  TProductCost
} from "../../api/endpoints/Order";
import { formatInteger, formatMegaBytes } from "../Format";

const discount = (value: number) => {
  return -1 * value;
}

const normalizeEpu = (epu: number) => {
  return Number((epu * 0.01).toFixed(2));
}

const productDailyVolume = (productCost: TProductCost) => {
  return formatMegaBytes(productCost.average_daily_volume * 0.000001);
}

const hfInformationCostV1 = (cost: TOrderCostV1) => {
  return (cost.data.total_cost?.hf_information_cost ?? 0) * 0.01;
}

const hfInformationCostAfterV1 = (cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5) => {
  return (cost.data.total_cost?.information_cost_hf ?? 0) * 0.01;
}

const hfInformationCost = (cost: TOrderCost) => {
  const { version } = cost;

  switch (version) {
    case 'v1':
      return hfInformationCostV1(cost);
    case 'v2':
      return hfInformationCostAfterV1(cost);
    case 'v3':
      return hfInformationCostAfterV1(cost);
    case 'v4':
      return hfInformationCostAfterV1(cost);
    case 'v5':
      return hfInformationCostAfterV1(cost);
    case 'v6':
      return 0;
  }
};

const standardInformationCost = (cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5) => {
  return (cost.data.total_cost?.information_cost_standard ?? 0) * 0.01;
}

const informationCost = (cost: TOrderCost) => {
  if (cost.version === 'v6') return 0;
  return (cost.data.total_cost?.information_cost ?? 0) * 0.01;
};

const informationCostDiscount = (cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5) => {
  const { total_cost } = cost.data;

  if (!total_cost) { return 0; }

  const { information_cost, information_cost_after_discount } = total_cost;

  return discount(information_cost - information_cost_after_discount) * 0.01;
};

const serviceChargeCost = (cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5 | TOrderCostV6) => {
  return (cost.data.total_cost?.service_charge ?? 0) * 0.01;
};

const serviceChargeCostDiscount = (cost: TOrderCostV2 | TOrderCostV3 | TOrderCostV4 | TOrderCostV5) => {
  const { total_cost } = cost.data;

  if (!total_cost) { return 0; }

  const { service_charge, service_charge_after_discount } = total_cost;

  return discount(service_charge - service_charge_after_discount) * 0.01;
}

const volumeBandCost = (cost: TOrderCostV6) => {
  return (cost.data.total_cost?.volume_band_cost ?? 0) * 0.01;
};

const servicePackageCost = (cost: TOrderCostV6) => {
  return (cost.data.total_cost?.service_package_cost ?? 0) * 0.01;
};

const totalCost = (cost: TOrderCost) => {
  if (cost.version === 'v6') {
    return (cost.data.total_cost?.service_charge ?? 0) * 0.01;
  }
  return (cost.data.total_cost?.total_cost ?? 0) * 0.01;
};

const handlingCost = (cost: TOrderCostV1) => {
  return (cost.data.total_cost?.handling_cost ?? 0) * 0.01;
};

const totalEpu = (cost: TOrderCost) => {
  if (cost.version === 'v6') return 0;
  const epu = cost.data.total_cost?.epu;

  return epu ? normalizeEpu(epu) : 0;
};

export {
  productDailyVolume,
  hfInformationCost,
  standardInformationCost,
  informationCost,
  informationCostDiscount,
  serviceChargeCost,
  serviceChargeCostDiscount,
  volumeBandCost,
  servicePackageCost,
  totalCost,
  handlingCost,
  totalEpu
}
